import { EmployeeProfileAiSummarySectionTranslation } from '@/assets/locales/views/employeeProfile/sections/aiSummary/employeeProfile.aiSummary.translation.pl.ts';

export const employeeProfileAiSummarySectionTranslation: EmployeeProfileAiSummarySectionTranslation =
  {
    content: {
      developmentAreas: 'Development Areas',
      strengths: 'Strengths',
    },
    headerTitle: 'AI Summary',
    headerTitleShorter: 'Summary',
  };
